import classNames from 'classnames';
import React from 'react';
import { ToolbarProps } from 'react-big-calendar';

import { IcBack2Icon, IcNextIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { Button, IconButton } from '@gem/ui-kit';

import { IEventCalendar } from '../../Content.types';
import { CalendarViewMenu } from '../CalendarViewMenu/CalendarViewMenu';
import { DatePicker } from '../DatePicker/DatePicker';
import { IToolbarProps } from '../MakeToolbar';
import { Setting } from '../Setting/Setting';
import { useToolbarPresenter } from '../Toolbar.presenter';
import styles from '../Toolbar.styles.m.css';

export const Toolbar: React.FC<ToolbarProps<IEventCalendar> & IToolbarProps> = ({
  date,
  view,
  onNavigate,
  onView,
  onCreate,
  accounts,
}) => {
  const { t } = useTranslation();
  const presenter = useToolbarPresenter({ onNavigate, onView, onCreate });

  return (
    <div className={classNames(styles.container, 'container-toolbar')}>
      <div className={styles.leftSide}>
        <Button
          onClick={presenter.onToday}
          theme="secondary"
          dataTest="calendar-range-today-button"
        >
          {t('calendar_today')}
        </Button>
        <IconButton
          Icon={IcBack2Icon}
          onClick={presenter.onPrev}
          theme="2"
          dataTest="calendar-range-back-button"
        />
        <IconButton
          Icon={IcNextIcon}
          onClick={presenter.onNext}
          theme="2"
          dataTest="calendar-range-next-button"
        />
        <DatePicker
          date={date}
          onChangeDate={presenter.onChangeDate}
          title={presenter.getFormatTitle(date, view)}
        />
      </div>
      <div className={styles.rigthSide}>
        <CalendarViewMenu
          value={view}
          items={presenter.viewList}
          onChange={presenter.onViewChange}
          menuClassName={styles.menuView}
          placement="bottom-end"
        />
        <Setting accounts={accounts} />
        <Button
          onClick={presenter.onCreate}
          theme="primary"
          dataTest="calendar-event-create-button"
        >
          {t('calendar_new_event')}
        </Button>
      </div>
    </div>
  );
};
